import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Emailresponse} from '../../models/email-response.model';

@Injectable({
  providedIn: 'root'
})
export class SendEmailRequestService {

  constructor(private readonly http: HttpClient) {
  }

  sendEmail(paymentReferenceNumber: string, emailAddress: string): Observable<Emailresponse> {
    const token = localStorage.getItem('authToken');

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    const payload = {
      objEmailRequest: {
        acsreceiptNumber: paymentReferenceNumber,
        fmstransactionNumber: paymentReferenceNumber,
        payerEMailID: emailAddress
      }
    };

    return this.http.post<Emailresponse>('api/send-email', payload, {headers});
  }
}
